import React from 'react';
import styles from './styles.module.scss';
import ReactHtmlParser from 'react-html-parser';
import Section from 'src/shared/components/Section';
import ResizingImage from 'src/shared/components/ResizingImage';
import useResize from 'src/shared/hooks/useResize';

interface Props {
    content: Array<any>;
}

const options = {
    decodeEntities: true,
    // eslint-disable-next-line no-unused-vars
};

const ArticleContent: React.FC<Props> = (props) => {
    const { breakpoint, screenSize } = useResize();

    return (
        <div className={styles.container}>
            {props.content.map((item) => {
                switch (item.contentType) {
                    case 'text.content':
                    case 'iframe':
                        return (
                            <Section key={item.articleContentId} containerClassName={`${styles.item} ${styles.html}`} dataTest="article" isArticle>
                                {ReactHtmlParser(item.contentBody, options)}
                            </Section>
                        );
                    case 'image':
                        return (
                            <Section key={item.articleContentId} containerClassName={styles.item} className={styles.itemImage} dataTest="image">
                                {/* TODO resize? */}
                                <ResizingImage
                                    className={styles.articleImage}
                                    alt={item.altTag}
                                    src={item.contentBody}
                                    title={item.altTag}
                                    willResize
                                />
                            </Section>
                        );
                    case 'video':
                        return (
                            <Section containerClassName={styles.item} dataTest="video" isArticle>
                                <video key={item.articleContentId} width="100%" controls autoPlay muted src={item.contentBody} />
                            </Section>
                        );

                    default:
                        return <></>;
                }
            })}
        </div>
    );
};

export default ArticleContent;
